export default function CameraRunSelector({ runs, value, onChange }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wide text-slate-500">Camera run</span>
      <select
        aria-label="Camera run"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm"
      >
        {!runs.length && <option value="">No runs yet</option>}
        {runs.map((run) => (
          <option key={run.id} value={run.id}>
            {run.run_id}{run.is_active ? " — active" : ""} ({run.image_count} images)
          </option>
        ))}
      </select>
    </label>
  );
}
